import { useRef, useState } from "react";
import { useTrendingContext } from "../../../context/TrendingContext";
import { formatDateTimeToString } from "../../../utils/formatDateTimeToString";

export const useChartOptions = () => {
	const { state, actions } = useTrendingContext();

	const debounceTimerRef = useRef<NodeJS.Timeout | null>(null);

	const handleZoom = ({ chart }: any) => {
		if (debounceTimerRef.current) {
			clearTimeout(debounceTimerRef.current);
		}
		debounceTimerRef.current = setTimeout(() => {
			// Handle zoom event and execute fetch
			const newStart = new Date(chart.scales.x.min);
			const newEnd = new Date(chart.scales.x.max);

			actions.setTotalScope({
				start: newStart,
				end: newEnd,
			});
		}, 1000);
	};

	const handlePan = ({ chart }: any) => {
		if (debounceTimerRef.current) {
			clearTimeout(debounceTimerRef.current);
		}
		debounceTimerRef.current = setTimeout(() => {
			// Handle pan event and execute fetch
			const newStart = new Date(chart.scales.x.min);
			const newEnd = new Date(chart.scales.x.max);

			actions.setTotalScope({
				start: newStart,
				end: newEnd,
				graphPan: true,
			});
		}, 1000);
	};

	return useState({
		animation: {
			duration: 0, // No animation
		},
		responsive: true,
		maintainAspectRatio: false,
		scales: {
			x: {
				type: "time" as const,

				ticks: {
					autoSkip: true,
					maxTicksLimit: 20,
					callback: (value: any, index: any, ticks: any) => {
						const currentDate = new Date(value);

						const time = formatDateTimeToString(currentDate).formattedTime;
						const date = formatDateTimeToString(currentDate).formattedDate;

						// Si es el primer tick, siempre muestra la fecha y hora
						if (index === 0) {
							return [time, date];
						}

						// De lo contrario, solo muestra la hora
						return time;
					},
				},

				grid: {
					display: true,
				},
			},
			y: {
				grid: {
					display: true,
				},
				afterUpdate(axis: any) {
					const chart = axis.chart;
					const keys = Object.keys(chart.scales).filter((sc) => sc !== "x");

					if (keys.length > 1) {
						for (const scaleKey in chart.scales) {
							const scale = chart.scales[scaleKey];

							if (scale.max === 1 && scale.min === 0) {
								(chart.scales[scaleKey] as any).display = false;
								(chart.scales[scaleKey] as any).options.display = false;
							} else {
								(chart.scales[scaleKey] as any).display = true;
								(chart.scales[scaleKey] as any).options.display = true;
							}
						}
					}
				},
			},
		},
		plugins: {
			tooltip: { enabled: false },
			legend: { display: false },
			zoom: {
				zoom: {
					wheel: { enabled: true, mode: "x" as const },
					pinch: { enabled: true, mode: "x" as const },
					onZoom: handleZoom,
					mode: "x" as const,
				},
				pan: {
					enabled: true,
					mode: "x" as const,
					onPan: handlePan,
				},
			},
		},
	});
};
